'use client';

import { MindfulAudioImg } from '@/config/img/mindfulAudio';
import { formatSecondsToYoutube } from '@/utils';
import { Image, Slider } from '@nextui-org/react';
import clsx from 'clsx';
import { createRef, useEffect, useState } from 'react';
import YouTube, { YouTubeProps } from 'react-youtube';

interface IProps {
  videoId: string;
}

export default function MdPlayer(props: IProps) {
  let videoRef = createRef<any>();
  const [duration, setDuration] = useState(0);
  const [curTime, setCurTime] = useState(0);
  const [ isPlay, setIsPlay ] = useState(false);
  const onPlayerReady: YouTubeProps['onReady'] = (event) => {
    // access to player in all event handlers via event.target
    event.target?.pauseVideo();
    console.log('🍿sub/Player.tsx:15/[event.target]:', event.target);

    // event.target.getDuration().then((res: number) => {
    //   console.log('📦sub/Player.tsx:17/[res]:', res);
    //   setDuration(res);
    // });
    // videoRef = event;
  };

  const opts: YouTubeProps['opts'] = {
    height: '72',
    width: '128',
    playerVars: {
      autoplay: 1,
      controls: 0,
    },
  };


  useEffect(() => {
    let timer: any;
    if (videoRef.current) {
      videoRef.current.internalPlayer.getDuration().then((res: number) => {
        setDuration(Math.ceil(res));
      });
      // 只在播放状态设置当前时间轴
      timer = setInterval(() => {
        videoRef.current.internalPlayer.getCurrentTime().then((res: number) => {
          setCurTime(Math.ceil(res));
        });
      }, 500);
    }
    return () => {
      clearInterval(timer);
    };

  }, [videoRef]);

  return (
    <div>
      <div className=' flex items-center  bg-white rounded-full'>
        <div className="img pr-[10px]">
          <Image
            src={ MindfulAudioImg.Play }
            className={ clsx(isPlay ? 'hidden' : 'block') }
            width={90}
            height={90}
            onClick={() => {
              videoRef.current.internalPlayer.playVideo();
            }}
            alt='play'
          />
          <Image
            src={ MindfulAudioImg.Stop }
            className={ clsx(isPlay ? 'block' : 'hidden') }
            width={90}
            height={90}
            onClick={() => {
              videoRef.current.internalPlayer.pauseVideo();
            }}
            alt='pause'
          />
        </div>
        <YouTube
          videoId={ props.videoId } //'M7lc1UVf-VE' 
          opts={opts}
          className='rounded-xl overflow-hidden pointer-events-none'
          onReady={onPlayerReady}
          onStateChange={({ data }) => {
            if ([-1, 0, 2, 5].includes(data)) {
              setIsPlay(false);
            } else {
              setIsPlay(true);
            }
          }}
          ref={videoRef}
        />
        <span className='text-[#404040] pl-4 pr-2'>{ formatSecondsToYoutube(curTime) }</span>
        <Slider
          size="sm"
          step={1}
          hideThumb={true}
          maxValue={duration}
          minValue={0}
          value={curTime}
          onChange={(value) => {
            if (value) {
              // 单一职责，这里进行视频的拖放。时间轴的值通过定时器获取是最准确的
              videoRef.current.internalPlayer.seekTo(value as number, true);
            }
          }}
          aria-label="audio"
          className='pl-[10px] flex-1'
          classNames={{
            filler: 'bg-[#E7FBB0]',
            track: '!border-0',
            // track: 'bg-white',
          }}
        />
        <span className='pl-2 pr-8 text-[#404040]'>{formatSecondsToYoutube(duration)}</span>
      </div>
    </div>
  );
}
